export default __webpack_public_path__ + "img/WB_RT_250MA_WF.c8d9721d8a8a086d4390cf4f68db6c44.jpg";